/**
 * 判断两个路径是否匹配（高亮逻辑）
 *
 * 规则：
 * 1. 如果 navId 是 '/'，则 path 必须全等匹配
 * 2. 如果 navId 是其他，则 path 必须以 navId 开头
 */
export function isNavActive(path: string, navId: string): boolean {
  return navId === "/" ? path === "/" : path.startsWith(navId);
}

/**
 * 判断路径是否为主导航路径
 *
 * @param path 当前访问的路径 (location.pathname 或 req.path)
 * @param navIds 所有主导航的 ID 列表
 */
export function isMainRoute(path: string, navIds: string[]): boolean {
  return navIds.some((navId) => isNavActive(path, navId));
}
